/* eslint-disable */
const turkish : any = {
    'email': 'bilgi@pembepanjur.com',
    'destek_hatti_phone': '0 (850) 558 08 08',
    'whatsapp_destek_phone': '0 (534) 927 00 00',
    'destek_hatti_fax':'0 (212) 570 69 71',
    'address': 'Yeşilköy Mah. Atatürk Cad. No: 12/2 EGS Business Park B3 Blok Ofis 264, Bakırköy 34149 - İstanbul',
    'mersis_no': '0721039342200014',
    'working_hours': '(09.00-01.00)',
    'company_name': 'Panjur Bilişim ve Danışmanlık Hizmetleri Ticaret AŞ',
    'success_title': 'Başarılı',
    'success_story': 'Hikayeniz başarı ile gönderildi.',
    'success_career': 'Kariyer başvurunuz başarı ile gönderildi.',
    'error_message_title': 'Başarısız.',
    'error_message_story': 'Hikayeniz gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.',
    'error_message_career': 'Kariyer başvurunuz gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.',
    'error_message_career_text': 'Kariyer başvurunuz için Aydınlatma Metni ve Açık Rıza Metni\'ni kabul etmeniz gerekiyor.',
    "edit_photo_guide_button": "Daha hızlı eşleşmeler için tavsiyeler",
    "edit_photo_main_photo": "Ana Fotoğraf",
    "edit_photo_guide_text_title": "Fotoğraf Tavsiyeleri",
    "edit_photo_guide_text_positive_desc": "Bunun gibi harika fotoğraflar ekle",
    "edit_photo_guide_text_positive_1": "Bir şeyler yaparken sen",
    "edit_photo_guide_text_positive_2": "Yüzünün gözüktüğü fotoğraflar",
    "edit_photo_guide_text_negative_desc": "Asla eklememen gereken fotoğraflar",
    "edit_photo_guide_text_negative_1": "Grupça çekilmiş fotoğraflar",
    "edit_photo_guide_text_negative_2": "Çıplaklık içeren foroğraflar",
    "edit_photo_guide_text_negative_3": "Yakın çekim fotoğraflar",
    "edit_photo_guide_text_negative_4": "Çocuk Fotoğrafları",
    "edit_photo_guide_text_negative_5": "Sahte Fotoğraflar",
    "edit_photo_guide_text_negative_6": "Reklam içerikli fotoğraflar",
}

export default turkish;
